import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

import { Button, Paper, Typography, Link, Box, Grid } from "@mui/material";

import { getLogout } from '../actions/viewinstance'

import { participantBiometricClear } from "../reducers/admincenter_biometrics";
import { datareportClear } from "../reducers/admincenter_datareport";
import { admingroupsClear } from "../reducers/admincenter_groups";
import { participantaddressClear } from "../reducers/admincenter_participantaddress";
import { participantdemographicClear } from "../reducers/admincenter_participantdemographics";
import { participantinviteClear } from "../reducers/admincenter_participantinvite";
import { participantmergeClear } from "../reducers/admincenter_participantmerge";
import { participantmiscClear } from "../reducers/admincenter_participantmisc";
import { participantmoveClear } from "../reducers/admincenter_participantmove";
import { participantpasswordClear } from "../reducers/admincenter_participantpassword";
import { participantphoneClear } from "../reducers/admincenter_participantphone";
import { participantresponseClear } from "../reducers/admincenter_responses";
import { reportcriteriaClear } from "../reducers/admincenter_reportcriteria";
import { adminparticipantClear } from "../reducers/admincenter_participants";
import { uireportClear } from "../reducers/admincenter_uireport";
import { profileClear } from "../reducers/profile";
import { navmenuClear } from "../reducers/reference_navmenu";
import { reportproductClear } from "../reducers/reference_reportproduct";

import {useTheme} from "@mui/material/styles"
import { privacypolicyClear } from "../reducers/privacy_policy";
import { termsandconditionsClear } from "../reducers/terms_and_conditions";

const Logout = () => {
  const [callVI, setCallVI] = useState(false);
  const {LanguageId} = useSelector(state=> state.contexts.entities) || -1
  const { viewInstance, settings } = useSelector(state => state.viewinstance)
  //const [viewInstance, setViewInstance] = useState(null)
  const dispatch = useDispatch()
  const theme = useTheme()

  useEffect(() => {
    if (!callVI && (!viewInstance || !viewInstance.LogoutPage)) {
      setCallVI(true);
      dispatch(getLogout(localStorage.getItem('group'),LanguageId))
    }
    if(callVI){

    localStorage.removeItem('persist:root')
        // participant
        dispatch(participantBiometricClear())
        dispatch(participantaddressClear())
        dispatch(participantdemographicClear())
        dispatch(participantinviteClear())
        dispatch(participantmergeClear())
        dispatch(participantmiscClear())
        dispatch(participantmoveClear())
        dispatch(participantpasswordClear())
        dispatch(participantphoneClear())
        dispatch(adminparticipantClear())
        // admin center
        dispatch(admingroupsClear())
        
        // reports
        dispatch(datareportClear())
        dispatch(reportcriteriaClear())
        dispatch(uireportClear())
    
        
        // survey data
        dispatch(participantresponseClear())
        
        // view instance data
        dispatch(navmenuClear())
        dispatch(profileClear())
        dispatch(reportproductClear())
        dispatch(privacypolicyClear())
        dispatch(termsandconditionsClear())
        
        // other data
      }

    
  },[callVI])

  useEffect(() => {
    console.log(theme)
  }, [theme, settings])



  if (viewInstance && viewInstance.LogoutPage && theme.palette.primary.main === settings.OrganizationSettingValues[0].List['THEME COLOR']) {

    return (
      <Box  p={3}>

        <Paper elevation={12}>
          <Grid container direction="row" xs={12} p={3} sx={{ textAlign: 'center', justifyContent:"center", alignItems:"center" }} spacing={2}>
            <Grid item xs={12} display="flex">

              <Link href={viewInstance.LogoutPage.ClientLogo.ClientLogoExternalLink} target="_blank"  >
                <img src={"../" + viewInstance.LogoutPage.ClientLogo.ClientLogoSource} alt={viewInstance.LogoutPage.ClientLogo.ClientLogoAltText} height="auto" width="100%"/>
              </Link>
            </Grid>

            <Grid item xs={12}>

              <Typography variant="h4" align="center">
                {viewInstance.LogoutPage.LogoutTitle}
              </Typography>
            </Grid>

            <Grid item xs={12}>

              <Typography variant="body1" align="center">
                {viewInstance.LogoutPage.LogoutSubtitle}
              </Typography>
            </Grid>

            <Grid item xs={12}>

              <RouterLink to={'/login?g=' + localStorage.getItem('group')} >
                <Button variant="contained">
                  {viewInstance.LogoutPage.BackToLoginLabel}
                </Button>

              </RouterLink>
            </Grid>

          </Grid>

        </Paper>
      </Box>
    );
  }
  return (
    <div></div>
  )

};

export default Logout;

/*LogoutPage
{
    "ClientLogo": {
        "ClientLogoSource": "../WsWebServicePlatform/handlers/WsGetImage.ashx?img=2B37CB53-99AF-41F0-9A15-0E17BEA74B38",
        "ClientLogoExternalLink": "https://www.Wellsource.com",
        "ClientLogoAltText": "Generic Alternate Text"
    },
    "FooterFrame": {
        "ByWellSource": "A Product of Wellsource",
        "TermsandConditionsLink": "Terms of Use",
        "PrivacyPolicyLink": "Privacy Policy",
        "ProductName": "WellSuite© IV"
    },
    "BackToLoginLabel": "Back To Login",
    "LogoutSubtitle": "See you again soon!",
    "LogoutTitle": "You Have Logged Out",
    "LogoutPageTitle": "Logout",
    "TimeoutTitle": "Your session has timed out.",
    "TimeoutFlag": "<<SESSION TIMEOUT FLAG>>"
}
*/